// extracted by mini-css-extract-plugin
export var section = "_2x-1";
export var topNav = "_2x-0";